<template>
  <div class="loading">
    <img src="../assets/PaigeLoadingGif.gif" alt="gemnote-logo" />
    <p v-if="text" class="inter">{{ text }}</p>
  </div>
</template>

<script>
export default {
  name: 'SmallLoader',
  props: {
    text: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
@import '../global.scss';

@keyframes flickerAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.gemnote-pulse {
  animation: flickerAnimation 2s infinite;
}

.loading {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 3rem 0rem;

  p {
    margin: 0.5rem 0rem;
    padding: 0;
    text-align: center;
    display: inline-block;
    font-weight: 500;
  }

  img {
    height: 4.5rem;
    object-fit: fill;
    margin-bottom: 1.5rem;
  }
}
</style>
